import { FunctionComponent, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { RequestFollowup } from "src/components/Buttons";
import ClientCreditApplicationTile from "src/components/dashboard/clients/ClientCreditApplicationTile";
import ClientInfoTile from "src/components/dashboard/clients/ClientInfoTile";
import ClientNotes from "src/components/dashboard/clients/ClientNotes";
import ProfileCompletion from "src/components/dashboard/clients/ProfileCompletion";
import {
  Button,
  LoadingSpinner,
  PageContainer,
  PageTitle,
} from "src/components/generic";
import AssignLeadModal from "src/components/generic/Modal/AssignLeadModal";
import { ToastStatus, useToast } from "src/context/ToastContext";
import { dynamo } from "src/utils";
import { userTypes } from "src/utils/types";

const ClientProfile: FunctionComponent = () => {
  const { id } = useParams();
  const { setToast } = useToast();
  const [client, setClient] = useState<userTypes.Client | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const toggleModal = () => setOpen(!open);

  const fetchClient = async () => {
    if (!id) return;

    try {
      const result = await dynamo.fetch.userById(id);

      setClient(result.user);
    } catch (error: any) {
      setToast({
        message: error?.message || "Failed to Fetch Client",
        status: ToastStatus.FAIL,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && !client) fetchClient();
  }, [id]);

  if (loading || !client) return <LoadingSpinner />;
  return (
    <PageContainer>
      <PageTitle title={client?.userInfo?.name} />
      <div>
        <RequestFollowup client={client} />
        <AssignLeadModal
          client={client}
          open={open}
          toggleModal={toggleModal}
        />
        <Link to="/dashboard/neatt/recall-map">
          <Button text="Recall MAP" />
        </Link>
      </div>

      <ClientInfoTile client={client} />
      <ClientNotes client={client} />
      <ProfileCompletion client={client} />
      <ClientCreditApplicationTile
        clientEmail={client.userInfo.email}
        leadAssigned={client?.leadAssigned || { id: "N/A", name: "N/A" }}
        cid={client.userId}
      />
    </PageContainer>
  );
};

export default ClientProfile;
